module.exports = __webpack_public_path__ + "images/display.svg";